import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { deleteAccount, logout } from '../../store/actions/auth.action';
import { useEffect } from 'react';
import { message } from 'antd';
import ROUTER from '../../routers/Routers';
import { useSearchParams } from 'react-router-dom';
import { openMessageSuccess } from '../../components/common/Message/openMessageSuccess';
import { useTranslation } from 'react-i18next';

const ConfirmDelete = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(deleteAccount({ token })).then(action => {
      if (action.payload?.data) {
        openMessageSuccess({ content: t('Account deleted successfully') });
        dispatch(logout()).then(() => {
          // window.location.replace('/');
          navigate('/');
        });
      } else navigate(ROUTER.LINK_EXPIRED);
    });
  });
  return (
    <div className="flex items-center justify-center">
      <h2>{t('Processing account deletion')}</h2>
    </div>
  );
};

export default ConfirmDelete;
